import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import EmployeeCard from '@/platform/common/components/EmployeeCard/EmployeeCard';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import SearchBarFilter from '@/platform/common/components/SearchBarFilter/SearchBarFilter';
import { useFilters } from '@/platform/hooks/useFilters';
import { localDate } from '@/platform/lib/utils';
import {
    Container,
    FilterBarDropdown,
    FilterBarPlaceholder,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/platform/ui';
import { Deferred, usePage } from '@inertiajs/react';

const NoAuthorisationView = () => {
    const { employees, resellers } = usePage().props;
    const { filters, updateFilters } = useFilters(['employees']);

    return (
        <Container fluid>
            <Segment>
                <SegmentHeader
                    header={`DGR positief zonder machtiging (${employees?.meta?.total || 0})`}
                />
                <SegmentContent>
                    <SearchBarFilter only={['employees']}>
                        <Deferred
                            data='resellers'
                            fallback={<FilterBarPlaceholder />}
                        >
                            <FilterBarDropdown
                                label={`Resellers (${filters?.resellers?.length || 0}/${Object.keys(resellers || {})?.length || 0})`}
                                options={Object.entries(resellers || {})?.map(
                                    ([id, name]) => ({ id, name })
                                )}
                                multiple
                                clearable
                                value={filters?.resellers || []}
                                onChange={values =>
                                    updateFilters('resellers', values)
                                }
                            />
                        </Deferred>
                    </SearchBarFilter>

                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>Klant</TableHeaderCell>
                                <TableHeaderCell>Entiteit</TableHeaderCell>
                                <TableHeaderCell>Medewerker</TableHeaderCell>
                                <TableHeaderCell>
                                    Datum indienst
                                </TableHeaderCell>
                                <TableHeaderCell textAlign='right'>
                                    Datum uitdienst
                                </TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {employees?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={5} />
                            )}

                            {employees?.data?.map(employee => (
                                <TableRow key={employee.id}>
                                    <TableCell collapsing>
                                        {employee.customer?.name}
                                    </TableCell>
                                    <TableCell collapsing>
                                        {employee.entity?.name}
                                    </TableCell>
                                    <TableCell>
                                        <EmployeeCard employee={employee} />
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip>
                                            <TooltipTrigger>
                                                {localDate(
                                                    employee?.employments?.at(0)
                                                        ?.starts_at
                                                )}
                                            </TooltipTrigger>
                                            <TooltipContent>
                                                <Table>
                                                    <TableHeader>
                                                        <TableRow>
                                                            <TableHeaderCell
                                                                colSpan={3}
                                                            >
                                                                Dienstverbanden
                                                            </TableHeaderCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableHeaderCell>
                                                                Pers.nr.
                                                            </TableHeaderCell>
                                                            <TableHeaderCell>
                                                                Ind.
                                                            </TableHeaderCell>
                                                            <TableHeaderCell textAlign='right'>
                                                                Uit.
                                                            </TableHeaderCell>
                                                        </TableRow>
                                                    </TableHeader>
                                                    <TableBody>
                                                        {employee?.employments?.map(
                                                            employment => (
                                                                <TableRow
                                                                    key={
                                                                        employment.id
                                                                    }
                                                                >
                                                                    <TableCell>
                                                                        {
                                                                            employment?.staff_number
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {localDate(
                                                                            employment?.starts_at
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell textAlign='right'>
                                                                        {localDate(
                                                                            employment?.ends_at
                                                                        )}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TooltipContent>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        {localDate(
                                            employee?.employments?.at(0)
                                                ?.ends_at
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>

                <SegmentFooter>
                    <CustomPagination
                        meta={employees?.meta}
                        only={['employees']}
                    />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default NoAuthorisationView;
